import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "./LandingPage.css";
import { useSelector, useDispatch } from "react-redux";
import { fetchCategories } from "../features/category/categorySlice";
import { useNavigate } from "react-router-dom";

const Navbar = ({ cartLength }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownVisible(e.target.value.length > 0);
  };

  const handleCloseDropdown = () => {
    setIsDropdownVisible(false);
  };

  const handleUserIconClick = () => {
    const isLoggedIn = localStorage.getItem("token"); // Check if the user is logged in
    if (!isLoggedIn) {
      setShowLoginModal(true); // Show the login modal if not logged in
    } else {
      alert("You are already logged in!"); // Replace with user profile navigation
    }
  };

  const handleProductClick = (id) => {
    console.log("id:", id);
    navigate(`/productdetail/${id}`); // Navigate to the product details page
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
  };

  const trendingKeywords = ["notebook", "notepad", "files"];
  const popularProducts = [
    { id: 1, name: "SLIP PAD NO.11", image: "/assets/images/items/25.jpg" },
    { id: 2, name: "SLIP PAD NO.12", image: "/assets/images/items/12.jpg" },
    { id: 3, name: "SLIP PAD NO.13", image: "/assets/images/items/23.jpg" },
  ];

  const dispatch = useDispatch();
  const {
    data: categories,
    isLoading,
    isError,
  } = useSelector((state) => state.category);

  // Fetch categories on component mount
  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  if (isLoading) {
    return <p>Loading categories...</p>;
  }

  if (isError) {
    return <p>Failed to load categories. Please try again later.</p>;
  }

  return (
    <>
      <header>
        <div className="my-header">
          {/* Top Section */}
          <div className="container-fluid bg-light py-2">
            <div className="d-flex justify-content-between align-items-center">
              {/* Customer Service Section */}
              <div className="customer-service d-none d-md-flex align-items-center">
                <i className="fas fa-phone-alt mr-2"></i>
                <span>Customer Service:</span>
                <span className="ml-1">+91-9415237778</span>
              </div>

              {/* Navbar Toggler */}
              <button
                className="navbar-toggler d-md-none"
                type="button"
                onClick={toggleMenu}
                aria-controls="navbarNavDropdown"
                aria-expanded={!isCollapsed}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Logo Section */}
              <Link to="/" className="navbar-brand mx-auto">
                <img
                  src="/assets/images/logo-image.png"
                  alt="Site Logo"
                  className="img-fluid"
                  style={{ height: "40px" }}
                />
              </Link>

              {/* Icons Section */}
              <div className="d-flex align-items-center">
                <input
                  className="form-control search-bar d-none d-lg-block"
                  type="search"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearchInputChange}
                  style={{ width: "200px", marginRight: "15px" }}
                />
                <div className="icons d-flex">
                  <button
                    className="nav-item mr-3"
                    onClick={handleUserIconClick}
                  >
                    <i className="fas fa-user"></i>
                  </button>
                  <Link to="/wishlistcomponent" className="nav-item mr-3">
                    <i className="fas fa-heart"></i>
                  </Link>
                  <Link to="/cart" className="nav-item position-relative">
                    <i className="fas fa-shopping-cart"></i>
                    <span
                      className="cart-count badge badge-pill badge-danger position-absolute"
                      style={{ top: "-10px", right: "-10px" }}
                    >
                      {cartLength || 0}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Search Dropdown */}
          {isDropdownVisible && (
            <div
              className="dropdown-menu show position-absolute"
              style={{ top: "60px", zIndex: 1050 }}
              onMouseLeave={handleCloseDropdown}
            >
              <div className="p-2">
                <h6>Trending Keywords</h6>
                {trendingKeywords.map((keyword, index) => (
                  <a key={index} href="#" className="dropdown-item small">
                    {keyword}
                  </a>
                ))}
              </div>
              <hr />
              <div className="p-2">
                <h6>Popular Products</h6>
                {popularProducts.map((product) => (
                  <a
                    key={product.id}
                    href="#"
                    className="dropdown-item d-flex align-items-center"
                  >
                    <img
                      src={product.image}
                      alt={product.name}
                      className="img-fluid"
                      style={{ height: "30px", marginRight: "10px" }}
                    />
                    {product.name}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>

        <nav className="navbar navbar-expand-lg navbar-light shadow-sm">
          <button
            className="navbar-toggler"
            type="button"
            aria-controls="navbarNavDropdown"
            aria-expanded={!isCollapsed}
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`navbar-collapse bg-white ${
              isCollapsed ? "collapse" : "show"
            }`}
            id="navbarNavDropdown"
            style={{ zIndex: 9999 }}
          >
            <ul className="navbar-nav mx-auto flex-wrap justify-content-center">
              {categories.map((category, index) => (
                <li className="nav-item dropdown" key={category._id}>
                  <span
                    className="nav-link dropdown-toggle small"
                    id={`categoryDropdown${index}`}
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {category.title}{" "}
                    <i className="fa fa-caret-down dropdown-icon"></i>
                  </span>
                  {/* <div
                    className="dropdown-menu"
                    aria-labelledby={`categoryDropdown${index}`}
                  >
                    {category.products.map((product) => (
                      <span className="dropdown-item small" key={product._id}>
                        {product.title}
                      </span>
                    ))}
                  </div> */}
                  <div
                    className="dropdown-menu"
                    aria-labelledby={`categoryDropdown${index}`}
                  >
                    {category.products.map((product) => (
                      <span
                        className="dropdown-item small"
                        key={product._id}
                        onClick={() => handleProductClick(product._id)} // Handle product click
                      >
                        {product.title}
                      </span>
                    ))}
                  </div>
                </li>
              ))}

              {/* Additional Navbar Items */}
              <li className="nav-item">
                <Link to="/about" className="nav-link small">
                  ABOUT US
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link small">
                  CONTACT US
                </Link>
              </li>
            </ul>

            {/* Search bar for smaller screens */}
            <form className="form-inline my-2 my-lg-0 d-lg-none">
              <input
                className="form-control search-bar"
                type="search"
                placeholder="Search"
                aria-label="Search"
              />
            </form>
          </div>
        </nav>
      </header>

      {/* Login Modal */}
      <Modal show={showLoginModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <label>Email Address *</label>
              <input
                type="email"
                className="form-control"
                placeholder="Email Address"
              />
            </div>
            <div className="form-group">
              <label>Password *</label>
              <input
                type="password"
                className="form-control"
                placeholder="Password"
              />
            </div>
            <Button className="btn btn-danger btn-block" type="submit">
              LOG IN
            </Button>
            <div className="mt-3 text-center">
              <a href="#" className="text-primary">
                Forgot your password?
              </a>
            </div>
            <Button className="btn btn-outline-danger btn-block mt-3">
              CREATE ACCOUNT
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Navbar;
